export const filterNulls = <T>(list: readonly (T | null)[] | null | undefined): T[] =>
  (list || []).filter((it): it is T => it !== null);
